import React from 'react';

interface TrialBannerProps {
  onSubscribeClick?: () => void;
}

// Trial banner disabled for now
export const TrialBanner: React.FC<TrialBannerProps> = () => null;
